import * as React from 'react';
import { Dropdown, DropdownProps, DropdownItemProps } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { AuthStore } from 'src/stores/authStore';

export default function OptionGenerator(
    storeName: string,
    filter: (authStore: AuthStore, input: any) => boolean,
    presets: (authStore?: AuthStore, presetProps?: any) => Array<DropdownItemProps> = () => [],
    propsUpdate?: (props: any, items?: any[], authStore?: AuthStore) => DropdownProps
) {
    return inject(storeName, 'authStore') (observer (
        class Options extends React.Component<DropdownProps & {presetProps?: any}> {
            render() {
                const storedLocation = this.props[storeName];
                let { authStore, presetProps, ...props } = this.props;
                let items = storedLocation.getParsedItems || [];
                items = items.slice();
                const options = items
                    .filter(filter.bind(this, authStore))
                    .map((obj: any) => {
                        return {
                            key: obj.typedId,
                            value: obj.typedId,
                            text: obj.name,
                            icon: obj.icon
                        };
                    })
                    .concat(presets(authStore, presetProps));
                let defaultValue: any = this.props.defaultValue;
                if (
                    defaultValue &&
                    defaultValue.slice
                ) {
                    defaultValue = defaultValue.slice();
                }

                if (propsUpdate) {
                    props = propsUpdate(props, items, authStore);
                }
        
                return (
                    <Dropdown
                        fluid
                        placeholder="Start typing.."
                        search
                        selection
                        {...props}
                        options={options}
                        defaultValue={defaultValue}
                    />
                );
            }
        })
    );
}



// WEBPACK FOOTER //
// ./src/container/Generic/Options.tsx